import { alpha, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,

    width: '100%',
    overflowY: 'auto'
  },

  inputContainer: {
    width: '100%',
    paddingBottom: 8,
    borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
  },

  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    padding: 16,
    borderRadius: 8,
    backgroundColor: theme.app.colors.input.background
  },

  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',

    '& span': {
      fontSize: theme.app.typography.label.fontSize,
      fontWeight: 500,
      color: theme.palette.primary.main
    }
  },

  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },

  info: {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,

    '& span:first-child': {
      fontWeight: 500,
      color: theme.palette.primary.main,
      fontSize: theme.app.typography.body.fontSize
    },

    '& span:last-child': {
      fontWeight: 500,
      color: '#000',
      fontSize: theme.app.typography.label.fontSize
    }
  },

  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
    position: 'relative'
  },

  noData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    borderRadius: 8,
    backgroundColor: theme.app.colors.input.background,

    '& span': {
      fontSize: theme.app.typography.label.fontSize,
      fontWeight: 500,
      color: theme.palette.primary.main
    }
  }
}))
